import { render } from "./질환별정밀프로그램.vue?vue&type=template&id=0326521a&scoped=true"
import script from "./질환별정밀프로그램.vue?vue&type=script&lang=js"
export * from "./질환별정밀프로그램.vue?vue&type=script&lang=js"

import "./질환별정밀프로그램.vue?vue&type=style&index=0&id=0326521a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0326521a"]])

export default __exports__